import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusIcon',
  standalone: true
})
export class StatusIconPipe implements PipeTransform {
  // Returns a FontAwesome class suffix (e.g. 'fa-check-circle'). Consumers
  // render with <i class="fas {{ status | statusIcon }}"></i>.
  transform(status: string | null | undefined): string {
    const statusLower = status?.toLowerCase() || '';
    if (statusLower.includes('accepted') || statusLower.includes('hired')) return 'fa-check-circle';
    if (statusLower.includes('rejected') || statusLower.includes('declined')) return 'fa-times-circle';
    if (statusLower.includes('pending') || statusLower.includes('review')) return 'fa-clock';
    return 'fa-info-circle';
  }
}
